import type { PaletteColor } from '@mui/material/styles/createPalette'
import { cyan } from './colors'

/** Palette primaire unique (identité Nabu), sans choix de preset. */
export const getPrimary = (): PaletteColor => cyan
